export const variantMode = (variant) => variant?.selectionMode || "manual";

// Item editor stores [height, width, thickness]. Mesh axes can be rotated and
// must not change which dimension rule applies to an item.
export function millingItemDimensions(item, fallback = {}) {
  try {
    const size = item.sizeArr || (typeof item.size === "string" ? JSON.parse(item.size) : item.size);
    if (Array.isArray(size)) return { width: Number(size[1]), height: Number(size[0]) };
  } catch (_) { /* Older items may only supply physical mesh dimensions. */ }
  return { width: fallback.widthMm, height: fallback.heightMm };
}

// Manual choices override automatic rules. Width rules always precede height rules;
// within one dimension the saved list order is the priority.
export function resolveMillingVariant(milling, selectedId, width, height) {
  if (!milling) return milling;
  const variants = milling.variants || [];
  const manual = selectedId && variants.find((v) =>
    v.variantId === selectedId && variantMode(v) === "manual");
  if (manual) return manual;
  for (const mode of ["width", "height"]) {
    const size = Number(mode === "width" ? width : height);
    if (!(size > 0 && Number.isFinite(size))) continue;
    const match = variants.find((v) => variantMode(v) === mode &&
      (v.minSizeMm != null || v.maxSizeMm != null) &&
      (v.minSizeMm == null || size >= v.minSizeMm) &&
      (v.maxSizeMm == null || size < v.maxSizeMm));
    if (match) return match;
  }
  return milling;
}
